import {API} from "@/api/generated";
import {
  clinic,
  clinicState,
  setting
} from "@/page/onlineAppointment/clinic/ClinicTypes";
import {defineStore} from "pinia";

export const useClinicStore = defineStore("clinic", {
  state: (): clinicState => ({
    clinic: {
      _id: "",
      clinic: "",
      servicesList: undefined,
      currency: {
        name: "",
        symbol: ""
      },
      userId: "",
      phone: "",
      email: "",
      logo: "",
      status: "",
      identIntegrationKey: [],
      create: "",
      update: "",
      addressList: [],
      specializationList: []
    },
    setting: {
      _id: "",
      userKey: "",
      servicesList: {},
      specializationList: [],
      create_at: "",
      updated_at: "",
      __v: 0
    }
  }),
  getters: {
    getClinic: (state: clinicState): clinic => {
      return state.clinic;
    },
    getSetting: (state: clinicState): setting => {
      return state.setting;
    }
  },

  actions: {
    async fetchClinic(): Promise<void> {
      const clinic = await API.getClinic();
      if (clinic?._id) this.clinic = {...clinic, _id: clinic._id};
    },
    async fetchSetting(): Promise<void> {
      const setting = await API.getSetting();
      this.setting = setting;
    },
    setClinic(item: clinic): void {
      this.clinic = item;
    },
    setSetting(item: setting): void {
      this.setting = item;
    }
  }
});
